import { Box } from "@mui/material";

const CardImage = ({
  margin,
  imageUrl,
  width,
  padding,
  height,
}: {
  margin: string | object;
  imageUrl: string;
  width: string | object;
  padding?: string;
  height: string | object;
}) => {
  return (
    <Box
      component="img"
      sx={{
        margin: margin ?? 0,
        width: width ?? 0,
        padding: padding ?? 0,
        height: height ?? 0,
        display: "flex",
        borderRadius: "5px",
        backgroundImage: "linear-gradient(to right, #f9f9f9, #f1f1f1)",
      }}
      src={imageUrl}
      loading="lazy"
    />
  );
};

export default CardImage;
